(function () {
  'use strict';

  function initSection(sectionEl) {
    if (!sectionEl) return;

    const grid = sectionEl.querySelector('[data-grid]');
    if (!grid) return;

    // Collection override renders server-side — only hide when nothing qualified
    if (sectionEl.dataset.static === 'true') {
      if (!grid.querySelector('.cwc_related-products__card')) sectionEl.hidden = true;
      return;
    }

    const url = sectionEl.dataset.url;
    if (!url || grid.dataset.loaded === 'true') return;

    fetch(url)
      .then(function (response) {
        if (!response.ok) throw new Error('Recommendations unavailable');
        return response.text();
      })
      .then(function (html) {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('.cwc_related-products [data-grid]');
        const cards = fresh ? fresh.querySelectorAll('.cwc_related-products__card') : [];

        if (!cards.length) {
          sectionEl.hidden = true;
          return;
        }

        grid.innerHTML = fresh.innerHTML;
        grid.dataset.loaded = 'true';
      })
      .catch(function () {
        sectionEl.hidden = true;
      });
  }

  function initAllSections() {
    document.querySelectorAll('.cwc_related-products').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllSections);
  } else {
    initAllSections();
  }

  document.addEventListener('shopify:section:load', function (event) {
    const section = event.target.querySelector('.cwc_related-products');
    if (section) initSection(section);
  });
})();
